/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './relatives.reducer';

export const RelativesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const relativesEntity = useAppSelector(state => state.relatives.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="relativesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.relatives.detail.title">Relatives</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.relatives.id">Id</Translate>
            </span>
          </dt>
          <dd>{relativesEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.relatives.active">Active</Translate>
            </span>
          </dt>
          <dd>{relativesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.relatives.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{relativesEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.relatives.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{relativesEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.relatives.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{relativesEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.relatives.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{relativesEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.relatives.patient">Patient</Translate>
          </dt>
          <dd>{relativesEntity.patient ? relativesEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.relatives.relative">Relative</Translate>
          </dt>
          <dd>{relativesEntity.relative ? relativesEntity.relative.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.relatives.relation">Relation</Translate>
          </dt>
          <dd>{relativesEntity.relation ? relativesEntity.relation.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/relatives" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/relatives/${relativesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RelativesDetail;
